import {ChangeDetectionStrategy, Component, ElementRef, inject, OutputEmitterRef, output, Signal, signal, WritableSignal} from '@angular/core';
import {DsBoxModule, DsListItemModule} from '@bmw-ds/components';
import {TranslateModule} from '@ngx-translate/core';
import {VehicleSearchService} from '../../../vehicle/vehicle-search-overlay/vehicle-search.service';

@Component({
  selector: 'app-vehicle-search-suggestions',
  templateUrl: './vehicle-search-suggestions.component.html',
  styleUrls: ['./vehicle-search-suggestions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DsBoxModule, DsListItemModule, TranslateModule],
  host: {
    '(document:mousedown)': 'onDocumentMouseDown($event)',
  },
})
export class VehicleSearchSuggestionsComponent {
  readonly suggestionSelected: OutputEmitterRef<string> = output<string>();

  readonly recentSearchStrings: Signal<string[]> = inject(VehicleSearchService).recentSearchStrings;

  readonly visible: WritableSignal<boolean> = signal<boolean>(false);

  private readonly elementRef: ElementRef<HTMLElement> = inject(ElementRef);

  show(): void {
    this.visible.set(this.recentSearchStrings().length > 0);
  }

  hide(): void {
    this.visible.set(false);
  }

  selectSuggestion(recentSearchString: string): void {
    this.hide();
    this.suggestionSelected.emit(recentSearchString);
  }

  protected onDocumentMouseDown(event: MouseEvent): void {
    if (this.visible() && !this.elementRef.nativeElement.contains(event.target as Node)) {
      this.hide();
    }
  }
}
